import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrderVersionPreference } from 'shared/const/orderVersionPreference';
import { writeOrderVersionPreferenceToStorage } from 'shared/lib/orderVersionPreference/orderVersionPreferenceStorage';

import { orderVersionPreferenceActions } from '../../slice/OrderVersionPreferenceSlice';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const setOrderVersionPreference = createAsyncThunk<
    OrderVersionPreference,
    OrderVersionPreference,
    ThunkConfig<string>
>(
    'orderVersionPreference/setOrderVersionPreference',
    async (preference, thunkApi) => {
        const { dispatch } = thunkApi;

        writeOrderVersionPreferenceToStorage(preference);
        dispatch(orderVersionPreferenceActions.setPreference(preference));

        return preference;
    },
);
